import { StyleSheet, TextStyle, ViewStyle } from 'react-native';

export const colors = {
  primary: '#4CAF50',
  secondary: '#FF5252',
  background: '#f5f5f5',
  surface: '#ffffff',
  text: {
    primary: '#333333',
    secondary: '#666666',
    disabled: '#999999',
  },
  success: '#4CAF50',
  error: '#F44336',
  warning: '#FF9800',
};

export const spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48,
};

export const typography = StyleSheet.create({
  title: {
    fontSize: 32,
    fontWeight: '700' as TextStyle['fontWeight'],
    color: colors.primary,
  },
  subtitle: {
    fontSize: 24,
    fontWeight: '600' as TextStyle['fontWeight'],
    color: colors.text.primary,
  },
  body: {
    fontSize: 16,
    color: colors.text.primary,
  },
  caption: {
    fontSize: 14,
    color: colors.text.secondary,
  },
});

type Styles = {
  container: ViewStyle;
  contentContainer: ViewStyle;
  card: ViewStyle;
  input: ViewStyle;
  buttonPrimary: ViewStyle;
  buttonSecondary: ViewStyle;
  buttonTextPrimary: TextStyle;
  buttonTextSecondary: TextStyle;
  wordDisplay: TextStyle;
  scoreText: TextStyle;
  statsContainer: ViewStyle;
  statBox: ViewStyle;
  statLabel: TextStyle;
  statValue: TextStyle;
};

export const globalStyles = StyleSheet.create<Styles>({
  container: {
    flex: 1,
    backgroundColor: colors.background,
  },
  contentContainer: {
    padding: spacing.md,
  },
  card: {
    backgroundColor: colors.surface,
    borderRadius: 10,
    padding: spacing.md,
    marginBottom: spacing.md,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  input: {
    borderWidth: 1,
    borderColor: colors.text.disabled,
    borderRadius: 5,
    padding: spacing.sm,
    marginBottom: spacing.md,
  },
  buttonPrimary: {
    backgroundColor: colors.primary,
    padding: spacing.md,
    borderRadius: 25,
  },
  buttonSecondary: {
    backgroundColor: colors.surface,
    padding: spacing.md,
    borderRadius: 25,
    borderWidth: 1,
    borderColor: colors.primary,
  },
  buttonTextPrimary: {
    color: colors.surface,
    fontSize: 16,
    fontWeight: '700' as TextStyle['fontWeight'],
    textAlign: 'center',
  },
  buttonTextSecondary: {
    color: colors.primary,
    fontSize: 16,
    fontWeight: '700' as TextStyle['fontWeight'],
    textAlign: 'center',
  },
  wordDisplay: {
    fontSize: 48,
    fontWeight: '700' as TextStyle['fontWeight'],
    color: colors.primary,
    textAlign: 'center',
    marginVertical: spacing.lg,
  },
  scoreText: {
    fontSize: 24,
    fontWeight: '700' as TextStyle['fontWeight'],
    color: colors.primary,
    textAlign: 'center',
  },
  statsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    marginVertical: spacing.md,
  },
  statBox: {
    alignItems: 'center',
  },
  statLabel: {
    fontSize: 14,
    color: colors.text.secondary,
  },
  statValue: {
    fontSize: 20,
    fontWeight: '700' as TextStyle['fontWeight'],
    color: colors.text.primary,
  },
}); 